import { useEffect, useState } from "react";
import axios from "axios";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

const MODES = [
  { id: "auto", label: "Holidays only" },
  { id: "on", label: "Always on" },
  { id: "off", label: "Off" },
];

export default function GiftBannerControl() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    axios.get(`${API}/gift-banner`).then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  const choose = async (mode) => {
    try {
      const { data } = await axios.put(`${API}/admin/gift-banner`, { mode }, { withCredentials: true });
      setStatus(data);
      toast.success(data.show ? "Gift banner is showing on the homepage." : "Gift banner is hidden right now.");
    } catch {
      toast.error("Could not update the gift banner.");
    }
  };
  if (!status) return null;
  return (
    <div className="border border-white/10 bg-[#121212] p-6 mb-10 flex flex-col md:flex-row md:items-center justify-between gap-5" data-testid="admin-gift-banner-control">
      <div>
        <p className="flex items-center gap-2 font-mono-ui text-[10px] uppercase tracking-[0.22em] text-primary-gold"><Gift className="w-4 h-4" /> Homepage gift banner</p>
        <p className="text-sm text-soft mt-2" data-testid="admin-gift-banner-status">
          {status.show ? <span className="text-[#4ade80]">Showing now · gifts $10.00</span> : "Hidden now · gifts $15.00"}
          {status.occasion ? ` · ${status.occasion.label.replace(/^(This|For) /, "")} season until ${new Date(status.occasion.ends).toLocaleDateString()}` : ""}
          {status.mode === "auto" && " · Holidays: Christmas (15 Nov–26 Dec), Valentine's (1–14 Feb), 2 weeks before Mother's & Father's Day"}
        </p>
      </div>
      <div className="flex border border-white/15 shrink-0">
        {MODES.map((m) => (
          <button
            key={m.id}
            onClick={() => choose(m.id)}
            data-testid={`admin-gift-banner-${m.id}`}
            className={`px-4 py-2 font-mono-ui text-[10px] uppercase tracking-[0.18em] transition-colors ${status.mode === m.id ? "bg-primary-gold text-[#0B0C10]" : "text-soft hover:text-text-primary"}`}
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  );
}
